import React from 'react';

function CustomTextAreaField({
  type,
  value,
  onChange,
  placeholder,
  rows,
  errorText,
}) {
  return (
    <>
      <div className="container">
        {errorText && <div className="error_text">{errorText}</div>}
        <textarea
          className="custom_text_area_field"
          type={type || 'text'}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={rows}
        ></textarea>
      </div>
      <style jsx>{`
        .error_text {
          color: #950810;
        }
        .container {
          display: grid;
          gap: 5px;
        }
        .custom_text_area_field {
          background: #141414;
          border: 1px solid #242424;
          border-radius: 4px;
          padding: 14px 16px;
          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: left;
          width: 100%;
          color: rgba(228, 228, 228, 0.75);
        }
      `}</style>
    </>
  );
}

export default CustomTextAreaField;
